
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import {MallKey} from "@/utils/config"
  
  import message from '@/components/message.vue';
  import {
    authsendSmsCode,
    bankFinanceSettlelist,
    settlementAccountinfo,
    settlementAccountsendCode,
    settlementAccountedit
  } from '@/api/user'
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-message': message,
    }
  })

  export default class ProductList extends Vue {
    private form:any = {
      CardHolder:'',
      BankId:null,
      Phone:'',
      BankCardNumber:'',
      ProviderId:'',
      FinanceOrderSettleRecordId:''
    }
    private banklist:any = []
    private num = 60
    private captcha1:any = {}
    private MallKey = MallKey
    private countdown:any = {}
    private code = ''
    private changeShow = false


    private mounted () {
      this.getbanklist()
      this.getinfo()
    }

    private checkchange(){
      if(!this.form.CardHolder){
        this.$message.error('请输入开户人')
        return
      }
      if(!this.form.BankId){
        this.$message.error('请选择开户行')
        return
      }
      if(!this.form.BankCardNumber){
        this.$message.error('请输入开户账号')
        return
      }
      if(!this.code){
        this.$message.error('请输入验证码')
        return
      }

      this.changeShow = true
    }
    private async confirmchange(){
      
      try{
        let res = await settlementAccountedit({
          ...this.form,
          SmsCode:this.code,
          ProviderId:this.$route.query.ProviderId
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.getinfo()
        }
      }finally{
        //
      }
    }
    private async getinfo(){
      try{
        let res = await settlementAccountinfo({
          ProviderId:this.$route.query.ProviderId
        })
        if(res.IsSuccess){
          this.form = res.Result
          this.form.BankId = this.form.BankId||null
          // for(let key in this.$route.query){
          //   this.form[key] = this.$route.query[key]||''
          // }
          this.code = ''
          // console.log(this.form)
        }
      }finally{
        //
      }
    }
    private async getbanklist(){
      try{
        let res = await bankFinanceSettlelist({})
        if(res.IsSuccess){
          this.banklist = res.Result
        }
      }finally{
        //
      }
    }
    private async checklogin(){
      // this.captcha1.show(); // 显示验证码

      try{
        let res = await settlementAccountsendCode({
          ProviderId:this.$route.query.ProviderId
        })
        if(res.IsSuccess){
          this.$message.success('已发送验证码')
          this.countdown = setInterval(()=>{
            if(this.num>1){
              this.num--
            }else{
              clearInterval(this.countdown)
              this.num = 60
            }
          },1000)
        }
      }finally{

      }
    }
  }
